


































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import { Priority, TicketType, TicketStatus, SortBy, SortOrder } from "../common/enum";
import ZenDeskTicketModel from "../models/ZenDeskTicketModel";
import TicketService from "@/services/ticket.service";
import Filters from "@/common/Filters";
import PagedResult from "../models/PagedResult";
import Shared from "@/common/shared";
import CompanyService from "../services/company.service";
import { CompanyModel } from "../models/CompanyModel";
import TicketSearchingModel from "../models/TicketSearchingModel";
import SignalRService from "../services/signalr.service";
import moment from "moment";
import RecentTicketModel from "../models/RecentTicketModel";
import vueCustomScrollbar from "vue-custom-scrollbar";

@Component({
  components: {
    vueCustomScrollbar,
  },
  filters: {
    truncate: Filters.truncate,
    difference: Filters.difference,
    upperCase: Filters.upperCase,
  },
})
export default class Tickets extends Mixins(BaseServiceMixin) {
  private priority = Priority;
  private ticketType = TicketType;
  private ticketStatus = TicketStatus;

  private ticketService!: TicketService;
  private companyService!: CompanyService;
  private signalRService!: SignalRService;

  private tickets: ZenDeskTicketModel[] = [];
  private selected: ZenDeskTicketModel = new ZenDeskTicketModel();
  private total = 0;
  private loading = false;
  private pageSize = Shared.defaultPageSize;
  private defaultSortOrder = "desc";
  private sortField = "createdAt";
  private sortOrder = "desc";

  private getStatusColor = Shared.getStatusColor;

  private ticketFilter = new TicketSearchingModel();

  public companies: CompanyModel[] = [];
  private ticketsFiltered: ZenDeskTicketModel[] = [];
  private recentTickets: RecentTicketModel[] = [];

  private sortBy(sortField: string): SortBy {
    switch (sortField) {
      case "priority":
        return SortBy.Priority;
      case "type":
        return SortBy.TicketType;
      case "status":
        return SortBy.Status;
      case "updatedAt":
        return SortBy.UpdateAt;
      default:
        return SortBy.CreatedAt;
    }
  }

  private get isZing() {
    return this.vuexStore.user ? this.vuexStore.user.isZing : false;
  }

  public async created() {
    this.ticketService = new TicketService(this.axiosInstance);
    this.companyService = new CompanyService(this.axiosInstance);
    this.signalRService = new SignalRService(this.axiosInstance, "zendeskTickets");
    this.signalRService.addHandler("ticketList-message", this.onNewTicket);
  }

  private async mounted() {
    await this.getTickets();
    if (this.isZing) {
      await this.getCompanies();
      try {
        await this.signalRService.connectHub();
      } catch (e) {
        // handle error
      }
      this.updateRecentTickets();
    }
  }

  private async getTickets() {
    this.loading = true;
    try {
      const response: PagedResult<ZenDeskTicketModel> = await this.ticketService.getTickets(this.ticketFilter);
      this.tickets = response.data;
      this.total = response.totalCount;
    } catch (error) {
      // Handle errors
    } finally {
      this.loading = false;
    }
  }

  /*
   * Handle select event
   */
  private async onSelect(row: ZenDeskTicketModel) {
    this.$router.push({ name: "View-Ticket", params: { id: row.id.toString() } });
  }

  /*
   * Handle sort event
   */
  private async onSort(field: string, order: string) {
    this.ticketFilter.sortParameters.sortBy = this.sortBy(field);
    this.ticketFilter.sortParameters.sortOrder = order === "asc" ? SortOrder.Asc : SortOrder.Desc;
    this.getTickets();
  }

  /*
   * Handle pagination event
   */
  private async onPageChange(page: number) {
    this.ticketFilter.pageParameters.page = page;
    this.getTickets();
  }

  private async getCompanies() {
    try {
      this.companies = await this.companyService.getCompanyList();
    } catch (error) {
      // Handle error
    }
  }

  private clearFilter() {
    const filter = this.ticketFilter;
    this.ticketFilter = Object.assign(new TicketSearchingModel(), {
      pageParameters: filter.pageParameters,
      sortParameters: filter.sortParameters,
    });
    this.getTickets();
  }

  private clearSearch() {
    this.ticketFilter.searchTerm = null;
    this.getTickets();
  }

  private updateRecentTickets() {
    const localStorageTickets = localStorage.getItem(Shared.localStorageKeys.RECENT_TICKETS);
    if (localStorageTickets) {
      this.recentTickets = JSON.parse(localStorageTickets);
    } else {
      this.recentTickets = [];
    }
  }

  private async onNewTicket(data: RecentTicketModel) {
    let recentTickets: RecentTicketModel[] = this.recentTickets.filter(
      (t: RecentTicketModel) => t.TicketId !== data.TicketId,
    );
    recentTickets.push(data);
    recentTickets = recentTickets.sort((a: RecentTicketModel, b: RecentTicketModel) =>
      moment(b.UpdatedAt).diff(moment(a.UpdatedAt)),
    );
    localStorage.setItem(Shared.localStorageKeys.RECENT_TICKETS, JSON.stringify(recentTickets));
    this.updateRecentTickets();
  }

  private onRecentTicketClick(ticketId: string) {
    const recentTickets: RecentTicketModel[] = this.recentTickets.filter(
      (t: RecentTicketModel) => t.TicketId !== parseInt(ticketId),
    );
    localStorage.setItem(Shared.localStorageKeys.RECENT_TICKETS, JSON.stringify(recentTickets));
    this.updateRecentTickets();
    const routeData = this.$router.resolve({ name: "View-Ticket", params: { id: ticketId } });
    window.open(routeData.href, "_blank");
  }

  private async destroyed() {
    try {
      await this.signalRService.disconnectHub();
    } catch (err) {
      // handle error
    }
  }
}
